import { render, staticRenderFns } from "./friend-info.vue?vue&type=template&id=f581ea3a&"
import script from "./friend-info.vue?vue&type=script&lang=js&"
export * from "./friend-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports